<div class="layout-row full-height panel-container">
  <div class="resize-handle"></div>

  <div class="layout-column flex">

<!--    <div class="layout-row layout-align-start-center padding-top-5 padding-left-5 padding-right-5">-->
<!--      <span class="flex"></span>-->
<!--      <bringoz-button type="tertiary"-->
<!--                      (onClick)="onClose.emit(this.index)"-->
<!--                      [ngbTooltip]="'close' | translate"-->
<!--                      openDelay="300"-->
<!--                      triggers="hover"-->
<!--                      aria-label="Close">-->
<!--        <bringoz-icon iconName="close"></bringoz-icon>-->
<!--      </bringoz-button>-->
<!--    </div>-->

    <div class="layout-column flex">
      <app-visit-plan-jobs-panel *ngIf="panel.selectedPanelType === 'jobs'"
                                 class="flex"
                                 [visitPlan]="visitPlan"
                                 [visitPlanRange]="visitPlanRange"
                                 [panel]="panel"
                                 [panels]="panels"
                                 [selectedIds]="selectedJobIds"
                                 [schedulingProjectJobs]="jobs"
                                 [schedulingProjectDays]="schedulingProjectDays"
                                 [programTypeAliasMap]="programTypeAliasMap"
                                 [isReloadJobs]="isReloadData"
                                 (onChangeSelectedIds)="onChangeJobsSelectedIds.emit($event)"
                                 (onChangeDateRange)="onChangeDateRange.emit($event)"
                                 (onCreateRoute)="onCreateRoute.emit({jobIds: $event.jobIds, resourceId: $event.resourceId})"
                                 (onLockJobChange)="onLockJobChange.emit($event)"
                                 (onPanelChange)="onPanelChange.emit($event)"
                                 (onClose)="onClose.emit(this.index)"
                                 (onAssign)="onAssign($event.event, $event.jobIds, $event.visitPlan, $event.dateRange)">

      </app-visit-plan-jobs-panel>

      <app-visit-plan-routes-panel *ngIf="panel.selectedPanelType === 'routes'"
                                   class="flex"
                                   [visitPlan]="visitPlan"
                                   [visitPlanRange]="visitPlanRange"
                                   [panel]="panel"
                                   [panels]="panels"
                                   [routes]="routes"
                                   [isLoadingRoutes]="isLoadingRoutes"
                                   [selectedRouteId]="panel.selectedRouteId"
                                   [selectedJobIds]="selectedJobIds"
                                   [selectedIds]="selectedRouteIds"
                                   [jobs]="jobs"
                                   [agentColorMap]="agentColorMap"
                                   [visitScheduleDays]="visitScheduleDays"
                                   [programTypeAliasMap]="programTypeAliasMap"
                                   (onEditCallServiceTime)="onEditCallServiceTime.emit($event)"
                                   (onCreateRoute)="onCreateRoute.emit({jobIds: $event.jobIds, resourceId: $event.resourceId})"
                                   (onMoveJobs)="onMoveJobs.emit($event)"
                                   (onSelectedRoutesChange)="onSelectedRoutesChange.emit($event)"
                                   (onSelectedJobsChange)="onChangeJobsSelectedIds.emit($event)"
                                   (onDeleteRoutes)="onDeleteRoutes.emit($event)"
                                   (onLockRouteChange)="onLockRouteChange.emit($event)"
                                   (onReoptimizeRoutes)="onReoptimizeRoutes.emit($event)"
                                   (onRoutePanelContextMenu)="onRoutePanelContextMenu.emit($event)"
                                   (onClose)="onClose.emit(this.index)"
                                   (onPanelChange)="onPanelChange.emit($event)"
                                   (onAssign)="onAssign($event.event, $event.jobIds, $event.visitPlan, $event.dateRange)">

      </app-visit-plan-routes-panel>
    </div>

  </div>
</div>
